import classNames from 'classnames';
import BookingPriceBreakdown from '@/components/organisms/booking-price-breakdown/booking-price-breakdown';
import Lightbox from '@/components/utilities/lightbox/lightbox';
import BookingPriceDetailsModalPaymentSummary from './components/booking-price-details-modal-payment-summary';
import styles from './booking-price-details-modal.module.scss';

export interface BookingPriceDetailsModalProps {
  /** The booking price details */
  bookingPriceDetails: Content.Components['BookingPriceDetailsDto'];
  /** The class name to apply */
  className?: string;
  /** The identifiers for the discount code query. */
  identifiers: {
    bookingStateId: string;
    id: string;
    pageId: string;
  };
  /** The installment information of the booking payment */
  installments?: Content.Components['MyTripUpcomingPaymentModuleInstallmentDto'][];
  /** Indicates whether the modal is open. */
  isOpen?: boolean;
  /** The callback to handle the close event. */
  onClose?: (value: boolean) => void;
  /** The payment summary shown below the price details */
  paymentSummary?: Content.Components['BookingPaymentSummaryDto'] | null;
}

const BookingPriceDetailsModal = ({
  bookingPriceDetails,
  className,
  identifiers,
  installments,
  isOpen = false,
  onClose,
  paymentSummary,
}: BookingPriceDetailsModalProps) => {
  return (
    <Lightbox
      className={classNames(styles.component, className)}
      footer={
        paymentSummary?.isOverpaid && (
          <BookingPriceDetailsModalPaymentSummary {...paymentSummary} />
        )
      }
      footerClassName={styles.footer}
      isCentered
      isFullWidthOnMobile
      isOpen={isOpen}
      onClose={() => onClose?.(false)}
      wrapperClassName={styles.lightboxWrapper}
    >
      <div className={styles.lightboxInnerWrapper}>
        <BookingPriceBreakdown
          bookingPriceDetails={bookingPriceDetails}
          identifiers={identifiers}
          installments={installments}
          isInModal
        />
      </div>
    </Lightbox>
  );
};

BookingPriceDetailsModal.displayName = 'BookingPriceDetailsModal';

export default BookingPriceDetailsModal;
